import { createStore /*, compose*/ } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

// import addresses from './actions/addresses';
import rootReducer from './reducers/index';

const defaultState = {
	// authenticated : localStorage.authenticated,
	user : null,
	addresses : []
}

const store = createStore(rootReducer, defaultState);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;


// WEBPACK FOOTER //
// ./src/store.js